<template>
  <div>
    <Navbar activeDirectory="admin" activePage="admin-users"></Navbar>

    <div class="container-fluid py-4">

      <!-- ===== PAGE HEADER ===== -->
      <div class="d-flex align-items-center justify-content-between flex-wrap mb-4" style="gap:12px;">
        <div class="d-flex align-items-center">
          <div class="au-header-icon mr-3" style="width:48px;height:48px;border-radius:14px;background:linear-gradient(135deg,#F7931E,#E07B00);display:flex;align-items:center;justify-content:center;box-shadow:0 4px 12px rgba(247,147,30,0.35);flex-shrink:0;">
            <i class="ti-user" style="color:#fff;font-size:1.5rem;"></i>
          </div>
          <div class="text-left">
            <h3 class="mb-0 font-weight-bold text-dark">Gestione Utenti</h3>
            <p class="mb-0 text-muted small">Gestisci utenti della piattaforma e operatori sul campo</p>
          </div>
        </div>

        <!-- Main section tabs -->
        <div class="cw-location-tabs mx-auto" style="min-width: 400px; background: #e2e8f0; padding: 4px; border-radius: 12px;" v-if="mode === 'read'">
          <button type="button" class="cw-loc-tab active" style="flex: 1; padding: 10px; font-size: 0.8rem; box-shadow: 0 2px 8px rgba(0,0,0,0.08); flex-direction: row; gap: 6px;">
            <i class="mdi mdi-account-group mr-1" style="font-size: 1.1rem;"></i> Backoffice
          </button>
          <button type="button" class="cw-loc-tab" style="flex: 1; padding: 10px; font-size: 0.8rem; flex-direction: row; gap: 6px;" @click="$router.push({name: 'admin-operators'})">
            <i class="mdi mdi-account-hard-hat mr-1" style="font-size: 1.1rem;"></i> Operatori sul Campo
          </button>
        </div>

        <button
          v-if="mode === 'read'"
          class="au-btn-submit"
          @click="setAddUser()"
        >
          <i class="mdi mdi-account-plus mr-1"></i> Aggiungi Utente
        </button>
      </div>

      <!-- ===== LIST MODE ===== -->
      <div v-if="mode === 'read'">
        <div class="au-card">
          <div class="cw-section-title">
            Elenco Utenti
          </div>

          <!-- Search + Filters -->
          <div class="d-flex align-items-center justify-content-between flex-wrap mb-4" style="gap:12px;">
            <!-- Search -->
            <div class="au-search-wrap">
              <i class="mdi mdi-magnify au-search-icon"></i>
              <input
                v-model="searchQuery"
                class="au-search-input"
                placeholder="Cerca per nome o email.."
              >
            </div>
            <!-- Filter tabs -->
            <div class="cw-location-tabs" style="min-width: 340px;">
              <button type="button" class="cw-loc-tab" :class="{ active: activeFilter === 'ALL' }" @click="activeFilter = 'ALL'">
                <span>Tutti</span>
              </button>
              <button type="button" class="cw-loc-tab" :class="{ active: activeFilter === 'B' }" @click="activeFilter = 'B'">
                <span>Admin</span>
              </button>
              <button type="button" class="cw-loc-tab" :class="{ active: activeFilter === 'G' }" @click="activeFilter = 'G'">
                <span>Supervisori</span>
              </button>
            </div>
          </div>

          <!-- User Table -->
          <div class="table-responsive">
            <table class="au-table">
              <thead>
                <tr>
                  <th>Utente</th>
                  <th>Email / Username</th>
                  <th>Azienda</th>
                  <th>Ruolo</th>
                  <th class="text-right">Azioni</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in filteredUsers" :key="item.id">
                  <td>
                    <div class="d-flex align-items-center">
                      <div class="au-avatar mr-3" :class="getAvatarClass(item.group)">
                        <i class="mdi" :class="getAvatarIcon(item.group)"></i>
                      </div>
                      <span class="font-weight-bold text-dark">{{ item.fullname }}</span>
                    </div>
                  </td>
                  <td class="text-muted small">{{ item.email }}</td>
                  <td>
                    <span class="au-company-badge">
                      <i class="mdi mdi-office-building-outline mr-1" style="font-size:0.75rem;"></i>
                      {{ item.company_name || 'Globale' }}
                    </span>
                  </td>
                  <td>
                    <span class="au-role-badge" :class="getRoleBadgeClass(item.group)">
                      {{ getGroupName(item.group) }}
                    </span>
                  </td>
                  <td class="text-right">
                    <button class="au-btn-action" @click="setEditUser(item)">
                      <i class="mdi mdi-pencil-outline mr-1"></i> Gestisci
                    </button>
                  </td>
                </tr>
                <tr v-if="filteredUsers.length === 0">
                  <td colspan="5" class="text-center py-5 text-muted">
                    <i class="mdi mdi-account-search mdi-48px d-block mb-2"></i>
                    Nessun utente trovato
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <!-- ===== EDIT MODE ===== -->
      <div v-if="mode === 'edit'">
        <div class="row">
          <!-- Left col: identity -->
          <div class="col-12 col-lg-5 mb-4">
            <div class="au-card h-100">
              <div class="cw-section-title">
                <span class="cw-step-num">1</span>Identità
              </div>

              <!-- Name -->
              <div class="form-group mb-4">
                <label class="cw-label">{{ isSquad(user.group) ? 'Nome Squadra' : 'Nome completo' }} <span class="text-danger">*</span></label>
                <div class="cw-input-wrap">
                  <i class="mdi mdi-account-outline cw-field-icon"></i>
                  <input v-model="user.fullname" class="cw-input" :placeholder="isSquad(user.group) ? 'Nome Squadra' : 'Nome completo'">
                </div>
              </div>

              <!-- Email / Username -->
              <div class="form-group mb-4">
                <label class="cw-label">{{ isSquad(user.group) ? 'Username' : 'Email' }} <span class="text-danger">*</span></label>
                <div class="cw-input-wrap">
                  <i class="mdi mdi-at cw-field-icon"></i>
                  <input v-model="user.email" class="cw-input" :type="isSquad(user.group) ? 'text' : 'email'">
                </div>
              </div>

              <!-- Azienda (developer only) -->
              <div class="form-group mb-4" v-if="isDeveloper">
                <label class="cw-label">Azienda <span class="text-danger">*</span></label>
                <div class="cw-select-wrap">
                  <i class="mdi mdi-office-building-outline cw-field-icon"></i>
                  <select v-model="user.fk_company" class="cw-select" @change="onCompanyChange()">
                    <option :value="null">Nessuna Azienda (Globale)</option>
                    <option v-for="c in companies" :key="c.id" :value="c.id">{{ c.nome }}</option>
                  </select>
                  <i class="mdi mdi-chevron-down cw-select-arrow"></i>
                </div>
              </div>

              <!-- Ruolo -->
              <div class="form-group mb-4">
                <label class="cw-label">Ruolo <span class="text-danger">*</span></label>
                <div class="cw-select-wrap cw-disabled">
                  <i class="mdi mdi-shield-account-outline cw-field-icon"></i>
                  <select v-model="mainRole" @change="onMainRoleChange()" class="cw-select" disabled>
                    <option value="B">Amministratore</option>
                    <option value="G">Supervisore</option>
                    <option value="SQUADRA">Squadra</option>
                  </select>
                  <i class="mdi mdi-chevron-down cw-select-arrow"></i>
                </div>
                <small class="text-muted mt-1 d-block"><i class="mdi mdi-lock-outline text-primary mr-1"></i>Il ruolo non è modificabile.</small>
              </div>

              <!-- Tipologia squadra -->
              <div class="form-group mb-0" v-if="mainRole === 'SQUADRA'">
                <label class="cw-label">Tipologia Squadra <span class="text-danger">*</span></label>
                <div class="cw-select-wrap">
                  <i class="mdi mdi-account-hard-hat-outline cw-field-icon"></i>
                  <select v-model="user.group" class="cw-select">
                    <option value="" disabled>Seleziona tipologia...</option>
                    <option v-for="t in filteredTeamTypes" :key="t.value" :value="t.value">{{ t.label }}</option>
                  </select>
                  <i class="mdi mdi-chevron-down cw-select-arrow"></i>
                </div>
              </div>
            </div>
          </div>

          <!-- Right col: permissions + teams -->
          <div class="col-12 col-lg-7 mb-4">
            <!-- Interventi abilitati (squadra) -->
            <div class="au-card mb-4" v-if="isSquad(user.group)">
              <div class="cw-section-title">
                <span class="cw-step-num">2</span>Interventi Abilitati
              </div>
              <div class="au-checkbox-grid">
                <div class="au-checkbox-item" v-for="item in interventi" :key="item.id">
                  <label class="au-checkbox-label" :for="'int_edit_' + item.id">
                    <input
                      type="checkbox"
                      class="au-checkbox-input"
                      :id="'int_edit_' + item.id"
                      :value="item.id"
                      v-model="selectedInterventiIds"
                    >
                    <span class="au-checkbox-custom"></span>
                    {{ item.nome }}
                  </label>
                </div>
                <div class="text-muted small" v-if="interventi.length === 0">
                  Nessun intervento disponibile per questa azienda.
                </div>
              </div>
            </div>

            <!-- Operatori della squadra -->
            <div class="au-card mb-4" v-if="isSquad(user.group)">
              <div class="cw-section-title">
                <span class="cw-step-num">3</span>Operatori Assegnati
              </div>
              <div class="au-checkbox-grid">
                <div class="au-checkbox-item" v-for="op in availableOperators" :key="op.id">
                  <label class="au-checkbox-label" :for="'op_edit_' + op.id">
                    <input
                      type="checkbox"
                      class="au-checkbox-input"
                      :id="'op_edit_' + op.id"
                      :value="op.id"
                      v-model="selectedOperatorIds"
                    >
                    <span class="au-checkbox-custom"></span>
                    {{ op.cognome }} {{ op.nome }} <small class="text-muted" v-if="op.team_name && op.team_id !== user.id">({{ op.team_name }})</small>
                  </label>
                </div>
                <div class="text-muted small" v-if="availableOperators.length === 0">
                  Nessun operatore dipendente disponibile.
                </div>
              </div>
            </div>

            <!-- Squadre associate (supervisore) -->
            <div class="au-card mb-4" v-if="user.group === 'G'">
              <div class="cw-section-title">
                <span class="cw-step-num">2</span>Squadre Associate
              </div>
              <div class="au-checkbox-grid">
                <div class="au-checkbox-item" v-for="team in availableTeams" :key="team.id">
                  <label class="au-checkbox-label" :for="'team_edit_' + team.id">
                    <input
                      type="checkbox"
                      class="au-checkbox-input"
                      :id="'team_edit_' + team.id"
                      :value="team.id"
                      v-model="selectedTeamIds"
                    >
                    <span class="au-checkbox-custom"></span>
                    {{ team.fullname }}
                  </label>
                </div>
                <div class="text-muted small" v-if="availableTeams.length === 0">
                  Nessuna squadra presente per questa azienda.
                </div>
              </div>
            </div>

            <!-- Danger zone -->
            <div class="au-card au-danger-zone">
              <div class="cw-section-title text-danger">
                <span class="cw-step-num au-step-danger">!</span>Zona Pericolosa
              </div>
              <div class="d-flex flex-wrap" style="gap:10px;">
                <button type="button" class="au-btn-warning" @click="passwordReset()">
                  <i class="mdi mdi-key-outline mr-1"></i> Rigenera Password
                </button>
                <button type="button" class="au-btn-danger" @click="deleteUser()">
                  <i class="mdi mdi-trash-can-outline mr-1"></i> Elimina Utente
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- Footer -->
        <div class="cw-footer d-flex align-items-center justify-content-between flex-wrap">
          <small class="text-muted">
            <i class="mdi mdi-asterisk text-danger" style="font-size:0.6rem; vertical-align:middle;"></i>
            Campi obbligatori
          </small>
          <div class="d-flex" style="gap:12px;">
            <button type="button" class="btn btn-light rounded-pill px-4 font-weight-semibold border" @click="mode = 'read'">
              <i class="mdi mdi-arrow-left mr-1"></i> Torna indietro
            </button>
            <button type="button" class="au-btn-submit" @click="updateUser()">
              <i class="mdi mdi-check-circle-outline mr-1"></i> Aggiorna Informazioni
            </button>
          </div>
        </div>
      </div>

      <!-- ===== ADD MODE ===== -->
      <div v-if="mode === 'add'">
        <div class="row">

          <!-- Left: identità + ruolo -->
          <div class="col-12 col-lg-5 mb-4">
            <div class="au-card h-100">
              <div class="cw-section-title">
                <span class="cw-step-num">1</span>Identità e Ruolo
              </div>

              <!-- Azienda (developer only) -->
              <div class="form-group mb-4" v-if="isDeveloper">
                <label class="cw-label">Azienda <span class="text-danger">*</span></label>
                <div class="cw-select-wrap">
                  <i class="mdi mdi-office-building-outline cw-field-icon"></i>
                  <select v-model="user.fk_company" class="cw-select" @change="onCompanyChange()">
                    <option :value="null">Nessuna Azienda (Globale)</option>
                    <option v-for="c in companies" :key="c.id" :value="c.id">{{ c.nome }}</option>
                  </select>
                  <i class="mdi mdi-chevron-down cw-select-arrow"></i>
                </div>
              </div>

              <!-- Ruolo -->
              <div class="form-group mb-4">
                <label class="cw-label">Ruolo Utente <span class="text-danger">*</span></label>
                <div class="cw-select-wrap">
                  <i class="mdi mdi-shield-account-outline cw-field-icon"></i>
                  <select v-model="mainRole" @change="onMainRoleChange()" class="cw-select">
                    <option value="B">Amministratore</option>
                    <option value="G">Supervisore</option>
                    <option value="SQUADRA">Squadra</option>
                  </select>
                  <i class="mdi mdi-chevron-down cw-select-arrow"></i>
                </div>
              </div>

              <!-- Tipologia squadra -->
              <div class="form-group mb-4" v-if="mainRole === 'SQUADRA'">
                <label class="cw-label">Tipologia Squadra <span class="text-danger">*</span></label>
                <div class="cw-select-wrap">
                  <i class="mdi mdi-account-hard-hat-outline cw-field-icon"></i>
                  <select v-model="user.group" class="cw-select">
                    <option value="" disabled>Seleziona tipologia...</option>
                    <option v-for="t in filteredTeamTypes" :key="t.value" :value="t.value">{{ t.label }}</option>
                  </select>
                  <i class="mdi mdi-chevron-down cw-select-arrow"></i>
                </div>
              </div>

              <!-- Nome (non squadra) -->
              <div class="form-group mb-4" v-if="!isSquad(user.group)">
                <label class="cw-label">Nome completo <span class="text-danger">*</span></label>
                <div class="cw-input-wrap">
                  <i class="mdi mdi-account-outline cw-field-icon"></i>
                  <input v-model="user.fullname" class="cw-input" placeholder="Nome completo">
                </div>
              </div>

              <!-- Email (non squadra) -->
              <div class="form-group mb-0" v-if="!isSquad(user.group)">
                <label class="cw-label">Email <span class="text-danger">*</span></label>
                <div class="cw-input-wrap">
                  <i class="mdi mdi-email-outline cw-field-icon"></i>
                  <input v-model="user.email" class="cw-input" type="email" placeholder="email@esempio.it">
                </div>
              </div>

              <!-- Campi squadra -->
              <div v-if="isSquad(user.group)">
                <div class="form-group mb-4">
                  <label class="cw-label">Commessa <span class="text-danger">*</span></label>
                  <div class="cw-select-wrap">
                    <i class="mdi mdi-briefcase-outline cw-field-icon"></i>
                    <select v-model="selectedCommessa" class="cw-select">
                      <option value="" disabled>Seleziona commessa...</option>
                      <option v-for="c in commesse" :key="c.id" :value="c.id">{{ c.nome }}</option>
                    </select>
                    <i class="mdi mdi-chevron-down cw-select-arrow"></i>
                  </div>
                </div>
                <div class="form-group mb-0">
                  <label class="cw-label">Nome Squadra <span class="text-danger">*</span></label>
                  <div class="cw-input-wrap">
                    <i class="mdi mdi-account-hard-hat-outline cw-field-icon"></i>
                    <input v-model="teamName" class="cw-input" placeholder="es. squadra_a">
                  </div>
                  <div class="au-username-preview mt-2">
                    <i class="mdi mdi-information-outline mr-1 text-primary"></i>
                    Username generato: <strong>C{{ selectedCommessa }}.{{ teamName || 'nome_squadra' }}{{ getGroupInitials(user.group) ? '.' + getGroupInitials(user.group) : '' }}</strong>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Right: interventi (squadra) / squadre associate (supervisore) -->
          <div class="col-12 col-lg-7 mb-4">

            <!-- Squadra → Interventi abilitati -->
            <div class="au-card mb-4" v-if="isSquad(user.group)">
              <div class="cw-section-title">
                <span class="cw-step-num">2</span>Interventi Abilitati
              </div>
              <div class="au-checkbox-grid">
                <div class="au-checkbox-item" v-for="item in interventi" :key="item.id">
                  <label class="au-checkbox-label" :for="'int_add_' + item.id">
                    <input
                      type="checkbox"
                      class="au-checkbox-input"
                      :id="'int_add_' + item.id"
                      :value="item.id"
                      v-model="selectedInterventiIds"
                    >
                    <span class="au-checkbox-custom"></span>
                    {{ item.nome }}
                  </label>
                </div>
                <div class="text-muted small" v-if="interventi.length === 0">
                  Nessun intervento disponibile.
                </div>
              </div>
            </div>

            <!-- Operatori della squadra (Aggiunta) -->
            <div class="au-card mb-4" v-if="isSquad(user.group)">
              <div class="cw-section-title">
                <span class="cw-step-num">3</span>Operatori Assegnati
              </div>
              <p class="text-muted small mb-3">
                <i class="mdi mdi-information-outline text-primary mr-1"></i>
                Seleziona i dipendenti da assegnare a questa squadra.
              </p>
              <div class="au-checkbox-grid">
                <div class="au-checkbox-item" v-for="op in availableOperators" :key="op.id">
                  <label class="au-checkbox-label" :for="'op_add_' + op.id">
                    <input
                      type="checkbox"
                      class="au-checkbox-input"
                      :id="'op_add_' + op.id"
                      :value="op.id"
                      v-model="selectedOperatorIds"
                    >
                    <span class="au-checkbox-custom"></span>
                    {{ op.cognome }} {{ op.nome }} <small class="text-muted" v-if="op.team_name">({{ op.team_name }})</small>
                  </label>
                </div>
                <div class="text-muted small" v-if="availableOperators.length === 0">
                  Nessun operatore dipendente disponibile.
                </div>
              </div>
            </div>

            <!-- Supervisore → Squadre associate -->
            <div class="au-card h-100" v-else-if="mainRole === 'G'">
              <div class="cw-section-title">
                <span class="cw-step-num">2</span>Squadre Associate
                <span class="ml-auto au-optional-badge">Opzionale</span>
              </div>
              <p class="text-muted small mb-3">
                <i class="mdi mdi-information-outline text-primary mr-1"></i>
                Seleziona le squadre che questo supervisore potrà gestire. Puoi modificarle in seguito.
              </p>
              <div class="au-checkbox-grid">
                <div class="au-checkbox-item" v-for="team in availableTeams" :key="team.id">
                  <label class="au-checkbox-label" :for="'team_add_' + team.id">
                    <input
                      type="checkbox"
                      class="au-checkbox-input"
                      :id="'team_add_' + team.id"
                      :value="team.id"
                      v-model="selectedTeamIds"
                    >
                    <span class="au-checkbox-custom"></span>
                    {{ team.fullname }}
                  </label>
                </div>
                <div class="text-muted small" v-if="availableTeams.length === 0">
                  <i class="mdi mdi-account-off-outline mr-1"></i>
                  Nessuna squadra presente per questa azienda.
                </div>
              </div>
            </div>

            <!-- Placeholder per Admin -->
            <div class="au-card h-100 d-flex align-items-center justify-content-center" v-else style="min-height:180px;">
              <div class="text-center text-muted">
                <i class="mdi mdi-information-outline mdi-36px d-block mb-2"></i>
                <p class="small mb-0">Seleziona il ruolo <strong>Squadra</strong> o <strong>Supervisore</strong><br>per abilitare opzioni aggiuntive.</p>
              </div>
            </div>
          </div>
        </div>

        <!-- Footer -->
        <div class="cw-footer d-flex align-items-center justify-content-between flex-wrap">
          <small class="text-muted">
            <i class="mdi mdi-asterisk text-danger" style="font-size:0.6rem; vertical-align:middle;"></i>
            Campi obbligatori
          </small>
          <div class="d-flex" style="gap:12px;">
            <button type="button" class="btn btn-light rounded-pill px-4 font-weight-semibold border" @click="mode = 'read'">
              <i class="mdi mdi-arrow-left mr-1"></i> Torna indietro
            </button>
            <button type="button" class="au-btn-submit" @click="saveUser()">
              <i class="mdi mdi-account-plus-outline mr-1"></i> Aggiungi Utente
            </button>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { Navbar } from "@/components";
import { resolveTeamToEdit } from "@/utils/operatorGrouping";

export default {
  components: {
    Navbar,
  },

  data() {
    return {
      tipologia: localStorage.getItem("tipologia"),
      myCompanyId: parseInt(localStorage.getItem("fk_company")) || null,
      users: [],
      user: undefined,
      companies: [],
      commesse: [],
      mode: "read",
      selectedCommessa: "",
      teamName: "",
      mainRole: "B",
      interventi: [],
      selectedInterventiIds: [],
      activeModules: [],
      allTeamTypes: JSON.parse(localStorage.getItem("teamTypes") || "[]"),
      searchQuery: "",
      activeFilter: "ALL",
      geometraTeams: [],
      selectedTeamIds: [],
      operators: [],
      selectedOperatorIds: []
    };
  },

  watch: {
    mode(nv) {
      if (nv == "read") {
        this.fetchUsers();
        this.fetchGeometraTeams();
        this.fetchOperators();
      } 
    },
  },

  computed: {
    isDeveloper() {
      return this.tipologia === "D";
    },
    filteredTeamTypes() {
      if (!this.user || !this.user.fk_company) {
        return this.allTeamTypes;
      }
      const activeModuleCodes = this.activeModules.map(m => m.codice);
      return this.allTeamTypes.filter(t => !t.module || activeModuleCodes.includes(t.module));
    },
    filteredUsers() {
      // Punto di partenza: solo utenti Backoffice (Admin + Supervisori).
      // Le squadre (isSquad) restano in this.users ma NON compaiono mai nella lista.
      let result = this.users.filter(u => u.group === 'B' || u.group === 'G');

      if (this.activeFilter === 'B') {
        result = result.filter(u => u.group === 'B');
      } else if (this.activeFilter === 'G') {
        result = result.filter(u => u.group === 'G');
      }
      // 'ALL' (e qualsiasi altro valore, incluso un 'SQUAD' residuo) => B + G

      if (this.searchQuery) {
        const term = this.searchQuery.toLowerCase();
        result = result.filter(u => 
          (u.fullname && u.fullname.toLowerCase().includes(term)) ||
          (u.email && u.email.toLowerCase().includes(term)) ||
          (u.company_name && u.company_name.toLowerCase().includes(term))
        );
      }

      return result;
    },
    availableTeams() {
      let teams = this.users.filter(u => this.isSquad(u.group));
      if (this.user && this.user.fk_company) {
        teams = teams.filter(u => u.fk_company === this.user.fk_company);
      }
      return teams;
    },
    availableOperators() {
      // Return non-autonomo operators
      let ops = this.operators.filter(o => !o.is_autonomo);
      if (this.user && this.user.fk_company) {
        ops = ops.filter(o => o.fk_company === this.user.fk_company);
      }
      return ops;
    }
  },

  mounted() {
    this.allTeamTypes = JSON.parse(localStorage.getItem("teamTypes") || "[]");
    if (this.tipologia !== "B" && this.tipologia !== "D") {
      this.$router.push({ name: "home" });
    } else {
      this.fetchUsers();
      this.fetchGeometraTeams();
      this.fetchCompanies();
      this.fetchOperators();
      this.fetchInterventi(this.isDeveloper ? null : this.myCompanyId);
      if (!this.isDeveloper) {
        this.fetchCompanyModules(this.myCompanyId);
        this.fetchCommesse(this.myCompanyId);
        this.loadTeamTypes(this.myCompanyId);
      }
    }
  },

  methods: {
    fetchUsers() {
      return this.axios.get("/get-users").then((response) => {
        this.users = response.data;
        this.maybeOpenEditTeamFromQuery();
      });
    },

    maybeOpenEditTeamFromQuery() {
      const editTeamId = this.$route.query.editTeam;
      if (editTeamId == null || editTeamId === "") return;
      const target = resolveTeamToEdit(this.users, editTeamId, (group) => this.isSquad(group));
      if (target) {
        this.setEditUser(target);
      }
      // non trovato / non-squadra → nessun errore, resta in vista lista (R4.8)
    },

    fetchOperators() {
      this.axios.get("/operators").then((response) => {
        this.operators = response.data;
      }).catch(err => {
        console.error("Errore recupero operatori:", err);
      });
    },

    fetchCompanies() {
      this.axios.get("/companies").then((response) => {
        this.companies = Array.isArray(response.data) ? response.data : [];
      }).catch(err => {
        console.error("Errore recupero aziende:", err);
      });
    },

    loadTeamTypes(companyId) {
      const defaultTeamTypes = [
        { value: "1", label: "Manutenzione stradale", module: "manutenzione_strade", initials: "MS" },
        { value: "2", label: "Manutenzione aree verdi", module: "verde_pubblico", initials: "MAV" },
        { value: "3", label: "Installazione impianto", module: "illuminazione", initials: "II" },
        { value: "4", label: "Riparazione guasti", module: "illuminazione", initials: "RG" },
        { value: "5", label: "Controllo impianti", module: "illuminazione", initials: "CI" },
        { value: "6", label: "Manutenzione ordinaria", module: "manutenzione_strade", initials: "MO" },
        { value: "7", label: "Gestione emergenza", module: "manutenzione_strade", initials: "GE" },
        { value: "8", label: "Pulizia e sanificazione", module: "pulizia_stradale", initials: "PP" },
        { value: "9", label: "Controllo qualità", module: "manutenzione_strade", initials: "CQ" }
      ];
      if (!companyId) {
        this.allTeamTypes = defaultTeamTypes;
        localStorage.setItem("teamTypes", JSON.stringify(defaultTeamTypes));
        return;
      }
      this.axios.get(`/companies/${companyId}/tipologie-squadra`).then((response) => {
        const customTypes = Array.isArray(response.data) ? response.data : [];
        const mappedCustom = customTypes.map(t => ({
          value: String(t.id),
          label: t.nome,
          module: t.module_code || "",
          initials: t.codice || ""
        }));
        const merged = [...defaultTeamTypes, ...mappedCustom];
        this.allTeamTypes = merged;
        localStorage.setItem("teamTypes", JSON.stringify(merged));
      }).catch(err => {
        console.error("Errore recupero tipologie squadra:", err);
      });
    },

    onCompanyChange() {
      this.fetchInterventi(this.user.fk_company);
      this.fetchCompanyModules(this.user.fk_company);
      this.fetchCommesse(this.user.fk_company);
      this.loadTeamTypes(this.user.fk_company);
      this.selectedInterventiIds = [];
      this.selectedCommessa = "";
    },

    fetchCommesse(companyId) {
      if (!companyId) {
        this.commesse = [];
        return;
      }
      this.axios.get(`/companies/${companyId}/commesse`).then(response => {
        this.commesse = Array.isArray(response.data) ? response.data : [];
        if (this.commesse.length > 0 && !this.selectedCommessa) {
           this.selectedCommessa = this.commesse[0].id;
        }
      }).catch(err => {
        console.error("Errore recupero commesse:", err);
      });
    },

    fetchInterventi(companyId = null) {
      const url = companyId ? `/companies/${companyId}/interventions` : "/tipologie-intervento";
      this.axios.get(url).then((response) => {
        this.interventi = Array.isArray(response.data) ? response.data : [];
      }).catch(err => {
        console.error("Errore recupero tipologie intervento:", err);
      });
    },

    setEditUser(item) {
      this.user = Object.assign({}, item);
      this.selectedInterventiIds = [];
      this.selectedTeamIds = [];
      this.selectedOperatorIds = [];
      if (this.user.group === 'B') {
        this.mainRole = 'B';
      } else if (this.user.group === 'G') {
        this.mainRole = 'G';
        this.selectedTeamIds = this.geometraTeams
          .filter(gt => gt.geometra && gt.geometra.id === this.user.id)
          .map(gt => gt.team.id);
      } else {
        this.mainRole = 'SQUADRA';
      }
      this.fetchInterventi(this.user.fk_company);
      this.fetchCompanyModules(this.user.fk_company);
      this.loadTeamTypes(this.user.fk_company);
      this.axios.get(`/user/${this.user.id}/tipologie-intervento`).then((response) => {
        this.selectedInterventiIds = response.data.map(i => i.id);
      }).catch(err => {
        console.error("Errore recupero interventi utente:", err);
      });
      if (this.isSquad(this.user.group)) {
        this.axios.get(`/teams/${this.user.id}/operators`).then((response) => {
          this.selectedOperatorIds = response.data.map(o => o.id);
        }).catch(err => {
          console.error("Errore recupero operatori squadra:", err);
        });
      }
      this.mode = 'edit';
    },

    fetchGeometraTeams() {
      this.axios.get('/geometra-teams').then(response => {
        this.geometraTeams = Array.isArray(response.data) ? response.data : [];
      }).catch(err => {
        console.error("Errore recupero geometra squadre:", err);
      });
    },

    onMainRoleChange() {
      if (this.mainRole === 'B') {
        this.user.group = 'B';
      } else if (this.mainRole === 'G') {
        this.user.group = 'G';
      } else if (this.mainRole === 'SQUADRA') {
        this.adjustTeamType(true);
      }
    },

    isSquad(group) {
      return this.allTeamTypes.some(t => t.value === group);
    },

    getGroupInitials(group) {
      const found = this.allTeamTypes.find(t => t.value === group);
      return found ? found.initials : "";
    },

    setAddUser() {
      const companyId = this.isDeveloper ? null : this.myCompanyId;
      this.user = {
        fullname: '',
        email: '',
        group: 'B',
        fk_company: companyId
      };
      this.selectedCommessa = '';
      this.teamName = '';
      this.mainRole = 'B';
      this.selectedInterventiIds = [];
      this.selectedOperatorIds = [];
      this.fetchInterventi(companyId);
      this.fetchCompanyModules(companyId);
      this.fetchCommesse(companyId);
      this.loadTeamTypes(companyId);
      this.mode = 'add';
    },

    fetchCompanyModules(companyId) {
      if (!companyId) {
        this.activeModules = [];
        this.adjustTeamType();
        return;
      }
      this.axios.get(`/companies/${companyId}/modules`)
        .then((response) => {
          this.activeModules = Array.isArray(response.data) ? response.data : [];
          this.adjustTeamType();
        })
        .catch((err) => {
          console.error("Errore recupero moduli azienda:", err);
          this.activeModules = [];
          this.adjustTeamType();
        });
    },

    adjustTeamType(force = false) {
      if (this.mainRole === 'SQUADRA' && this.user) {
        const validValues = this.filteredTeamTypes.map(t => t.value);
        if (validValues.length > 0 && !validValues.includes(this.user.group)) {
          if (force || this.mode === 'add') {
            this.user.group = validValues[0];
          }
        }
      }
    },

    saveUser() {
      var formData = new FormData();
      if (this.isSquad(this.user.group)) {
        const initials = this.getGroupInitials(this.user.group);
        this.user.email = 'C' + this.selectedCommessa + '.' + this.teamName + (initials ? '.' + initials : '');
        this.user.fullname = this.teamName;
        formData.append('commessa', this.selectedCommessa);
      }
      formData.append('email', this.user.email);
      formData.append('fullname', this.user.fullname);
      formData.append('group', this.user.group);
      if (this.user.fk_company) {
        formData.append('fk_company', this.user.fk_company);
      }
      this.axios.post("/subscribe", formData).then(response => {
        if (response.data['success']) {
          const newUserId = response.data['id'];
          if (newUserId && this.isSquad(this.user.group)) {
            // Salva interventi abilitati per la squadra
            this.axios.post(`/user/${newUserId}/tipologie-intervento`, {
              interventi: this.selectedInterventiIds
            }).then(() => {
              // Salva operatori assegnati
              return this.axios.post(`/teams/${newUserId}/operators`, {
                operator_ids: this.selectedOperatorIds
              });
            }).then(() => {
              this.mode = 'read';
            }).catch(err => {
              console.error(err);
              this.mode = 'read';
            });
          } else if (newUserId && this.user.group === 'G' && this.selectedTeamIds.length > 0) {
            // Salva squadre associate al supervisore
            this.axios.put('/geometra-teams/list', {
              geometra_id: newUserId,
              team_ids: this.selectedTeamIds
            }).then(() => {
              this.mode = 'read';
            }).catch(err => {
              console.error("Errore salvataggio associazioni squadre:", err);
              this.mode = 'read';
            });
          } else {
            this.mode = 'read';
          }
        }
      });
    },

    updateUser() {
      var formData = new FormData();
      formData.append('id', this.user.id);
      formData.append('email', this.user.email);
      formData.append('fullname', this.user.fullname);
      formData.append('group', this.user.group);
      if (this.user.fk_company) {
        formData.append('fk_company', this.user.fk_company);
      }
      this.axios.post("/user/update", formData).then(response => {
        if (response.data['success']) {
          if (this.isSquad(this.user.group)) {
            // Aggiorna interventi e operatori
            this.axios.post(`/user/${this.user.id}/tipologie-intervento`, {
              interventi: this.selectedInterventiIds
            }).then(() => {
              return this.axios.post(`/teams/${this.user.id}/operators`, {
                operator_ids: this.selectedOperatorIds
              });
            }).then(() => {
              this.mode = 'read';
            }).catch(err => {
              console.error(err);
              this.mode = 'read';
            });
          } else if (this.user.group === 'G') {
            this.axios.put('/geometra-teams/list', {
              geometra_id: this.user.id,
              team_ids: this.selectedTeamIds
            }).then(() => {
              this.mode = 'read';
            }).catch(err => {
              console.error("Errore salvataggio associazioni squadre:", err);
              this.mode = 'read';
            });
          } else {
            this.mode = 'read';
          }
        }
      });
    },

    passwordReset() {
      var formData = new FormData();
      formData.append('id', this.user.id);
      this.axios.post("/password-regeneration", formData).then(response => {
        if (response.data['success']) {
          this.mode = 'read';
        }
      });
    },

    deleteUser() {
      this.$swal({
        title: 'Sei sicuro?',
        text: "Non potrai annullare questa operazione!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'Sì, elimina!',
        cancelButtonText: 'Annulla'
      }).then((result) => {
        if (result.isConfirmed) {
          var formData = new FormData();
          formData.append('id', this.user.id);
          this.axios.post("/user/delete", formData).then(response => {
            if (response.data['success']) {
              this.$swal('Eliminato!', 'Utente eliminato con successo.', 'success');
              this.mode = 'read';
            } else {
              this.$swal('Errore', response.data['error'] || "Impossibile eliminare l'utente.", 'error');
            }
          });
        }
      });
    },

    getGroupName(group) {
      if (group == "B") return "Amministratore";
      if (group == "G") return "Supervisore";
      const found = this.allTeamTypes.find(t => t.value === group);
      return found ? found.label : group;
    },

    getRoleBadgeClass(group) {
      if (group === 'B') return 'au-role-admin';
      if (group === 'G') return 'au-role-supervisor';
      return 'au-role-squad';
    },

    getAvatarClass(group) {
      if (group === 'B') return 'au-avatar-admin';
      if (group === 'G') return 'au-avatar-supervisor';
      return 'au-avatar-squad';
    },

    getAvatarIcon(group) {
      if (group === 'B') return 'mdi-shield-account';
      if (group === 'G') return 'mdi-account-supervisor';
      return 'mdi-account-hard-hat';
    },

    getUsernamePlaceholder(group) {
      if (this.isSquad(group)) return "es. C1.squadra_a";
      return "Email";
    },

    getGroupBadge(group) {
      return {
        "badge-primary": group == "B",
        "badge-secondary": group == "G",
        "badge-info": this.isSquad(group),
      };
    },
  },
};
</script>

<style scoped>
/* =========================================
   ADMIN USERS — Premium UI (RoadME DS)
   ========================================= */

/* Shared tokens from style.md */
.cw-section-title {
  font-size: 0.82rem; font-weight: 700;
  text-transform: uppercase; letter-spacing: 0.08em;
  color: #64748b; margin-bottom: 22px;
  display: flex; align-items: center;
}
.cw-step-num {
  width: 22px; height: 22px; border-radius: 50%;
  background: linear-gradient(135deg, #F7931E, #E07B00);
  color: #fff; font-size: 0.7rem; font-weight: 800;
  display: inline-flex; align-items: center; justify-content: center;
  margin-right: 10px; flex-shrink: 0;
}
.cw-label {
  font-size: 0.75rem; font-weight: 700;
  text-transform: uppercase; letter-spacing: 0.07em;
  color: #94a3b8; margin-bottom: 8px; display: block;
}
.cw-input-wrap { position: relative; display: flex; align-items: center; }
.cw-field-icon {
  position: absolute; left: 12px;
  color: #94a3b8; font-size: 1rem; z-index: 2; pointer-events: none;
}
.cw-input {
  width: 100%; height: 46px; padding: 0 14px 0 36px;
  border: 1.5px solid #e2e8f0; border-radius: 10px;
  background: #f8fafc; font-size: 0.92rem; font-weight: 500; color: #1e293b;
  transition: border-color 0.2s, box-shadow 0.2s; outline: none;
}
.cw-input:focus {
  border-color: #F7931E; box-shadow: 0 0 0 3px rgba(247,147,30,0.12); background: #fff;
}
.cw-select-wrap { position: relative; display: flex; align-items: center; }
.cw-select {
  width: 100%; height: 46px; padding: 0 38px 0 36px;
  border: 1.5px solid #e2e8f0; border-radius: 10px;
  background: #f8fafc; appearance: none; -webkit-appearance: none;
  font-size: 0.92rem; font-weight: 500; color: #1e293b;
  cursor: pointer; transition: border-color 0.2s, box-shadow 0.2s; outline: none;
}
.cw-select:focus {
  border-color: #F7931E; box-shadow: 0 0 0 3px rgba(247,147,30,0.12); background: #fff;
}
.cw-select-arrow {
  position: absolute; right: 14px;
  color: #94a3b8; font-size: 1rem; pointer-events: none;
}
.cw-disabled { opacity: 0.5; pointer-events: none; }
.cw-footer {
  background: #fff; border-radius: 14px;
  padding: 18px 24px; border: 1px solid rgba(0,0,0,0.05);
  box-shadow: 0 2px 12px rgba(0,0,0,0.05);
}

/* Location tabs reuse */
.cw-location-tabs {
  display: flex; background: #f1f5f9;
  border-radius: 12px; padding: 4px; gap: 2px;
}
.cw-loc-tab {
  flex: 1; display: flex; flex-direction: column;
  align-items: center; justify-content: center; gap: 3px;
  padding: 10px 6px; border: none; border-radius: 9px;
  background: transparent; color: #94a3b8;
  font-size: 0.7rem; font-weight: 700;
  text-transform: uppercase; letter-spacing: 0.04em;
  cursor: pointer; transition: all 0.2s;
}
.cw-loc-tab .mdi { font-size: 1.1rem; }
.cw-loc-tab:hover { background: rgba(255,255,255,0.7); color: #F7931E; }
.cw-loc-tab.active { background: #fff; color: #E07B00; box-shadow: 0 2px 8px rgba(0,0,0,0.08); }

/* ── Page-specific ── */

/* Header icon */
.cw-header-icon {
  width: 48px; height: 48px; border-radius: 14px;
  background: linear-gradient(135deg, #F7931E, #E07B00);
  display: flex; align-items: center; justify-content: center;
  box-shadow: 0 4px 12px rgba(247,147,30,0.35); flex-shrink: 0;
}
.cw-header-icon .mdi { color: #fff; font-size: 1.5rem; }

/* Card */
.au-card {
  background: #fff; border-radius: 16px;
  box-shadow: 0 2px 16px rgba(0,0,0,0.07);
  padding: 28px; border: 1px solid rgba(0,0,0,0.05);
}

/* Submit btn */
.au-btn-submit {
  display: inline-flex; align-items: center;
  padding: 10px 24px; border: none; border-radius: 30px;
  background: linear-gradient(135deg, #F7931E, #E07B00);
  color: #fff; font-size: 0.88rem; font-weight: 700;
  cursor: pointer; box-shadow: 0 4px 14px rgba(247,147,30,0.35);
  transition: all 0.2s;
}
.au-btn-submit:hover {
  background: linear-gradient(135deg, #E07B00, #C96A00);
  box-shadow: 0 6px 18px rgba(247,147,30,0.45);
  transform: translateY(-1px);
}

/* Search */
.au-search-wrap {
  position: relative; display: flex; align-items: center;
  background: #f8fafc; border: 1.5px solid #e2e8f0;
  border-radius: 30px; height: 44px; padding: 0 16px 0 38px;
  min-width: 260px; transition: border-color 0.2s;
}
.au-search-wrap:focus-within { border-color: #F7931E; background: #fff; }
.au-search-icon {
  position: absolute; left: 14px; color: #94a3b8; font-size: 1rem; pointer-events: none;
}
.au-search-input {
  border: none; background: transparent; outline: none;
  font-size: 0.9rem; color: #1e293b; width: 100%;
}

/* Table */
.au-table { width: 100%; border-collapse: collapse; }
.au-table thead tr {
  border-bottom: 2px solid #f1f5f9;
}
.au-table thead th {
  padding: 10px 16px; font-size: 0.72rem; font-weight: 700;
  text-transform: uppercase; letter-spacing: 0.07em; color: #94a3b8;
  background: #f8fafc;
}
.au-table tbody tr {
  border-bottom: 1px solid #f1f5f9;
  transition: background 0.15s;
}
.au-table tbody tr:hover { background: #f8fafc; }
.au-table td { padding: 14px 16px; vertical-align: middle; }

/* Avatar */
.au-avatar {
  width: 36px; height: 36px; border-radius: 10px;
  display: flex; align-items: center; justify-content: center;
  flex-shrink: 0;
}
.au-avatar .mdi { font-size: 1rem; }
.au-avatar-admin { background: #FEF1E0; color: #F7931E; }
.au-avatar-supervisor { background: #f0fdf4; color: #22c55e; }
.au-avatar-squad { background: #fef9c3; color: #ca8a04; }

/* Role badge */
.au-role-badge {
  display: inline-block; padding: 3px 10px; border-radius: 20px;
  font-size: 0.72rem; font-weight: 700; letter-spacing: 0.04em;
}
.au-role-admin { background: #FEF1E0; color: #E07B00; }
.au-role-supervisor { background: #f0fdf4; color: #16a34a; }
.au-role-squad { background: #fef9c3; color: #92400e; }

/* Company badge */
.au-company-badge {
  display: inline-block; padding: 3px 10px; border-radius: 20px;
  font-size: 0.78rem; font-weight: 600;
  background: #f1f5f9; color: #64748b;
}

/* Action btn */
.au-btn-action {
  display: inline-flex; align-items: center;
  padding: 6px 16px; border-radius: 20px; border: 1.5px solid #e2e8f0;
  background: #fff; color: #F7931E; font-size: 0.8rem; font-weight: 700;
  cursor: pointer; transition: all 0.15s;
}
.au-btn-action:hover {
  background: #FEF1E0; border-color: #F7931E;
}

/* Checkbox grid */
.au-checkbox-grid {
  display: grid; grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
  gap: 10px;
}
.au-checkbox-label {
  display: flex; align-items: center; gap: 10px;
  font-size: 0.88rem; font-weight: 600; color: #334155;
  cursor: pointer; padding: 10px 14px;
  border: 1.5px solid #e2e8f0; border-radius: 10px;
  background: #f8fafc; transition: all 0.15s; user-select: none;
}
.au-checkbox-label:hover { border-color: #F5B871; background: #FEF1E0; color: #E07B00; }
.au-checkbox-input {
  position: absolute; opacity: 0; width: 0; height: 0; pointer-events: none;
}
.au-checkbox-custom {
  width: 18px; height: 18px; border-radius: 5px;
  border: 2px solid #cbd5e1; background: #fff;
  display: flex; align-items: center; justify-content: center;
  flex-shrink: 0; transition: all 0.15s;
}
.au-checkbox-input:checked + .au-checkbox-custom {
  background: linear-gradient(135deg, #F7931E, #E07B00);
  border-color: #F7931E;
}
.au-checkbox-input:checked + .au-checkbox-custom::after {
  content: '✓'; color: #fff; font-size: 11px; font-weight: 900; line-height: 1;
}
/* Highlight the whole label when selected (does NOT override the custom square) */
.au-checkbox-label:has(.au-checkbox-input:checked) {
  border-color: #F7931E; background: #FEF1E0; color: #E07B00;
}

/* Danger zone */
.au-danger-zone { border: 1.5px solid #fee2e2; background: #fff5f5; }
.au-step-danger { background: linear-gradient(135deg, #ef4444, #b91c1c); }

.au-btn-warning {
  display: inline-flex; align-items: center;
  padding: 8px 18px; border-radius: 20px;
  border: 1.5px solid #fde68a; background: #fffbeb;
  color: #92400e; font-size: 0.82rem; font-weight: 700;
  cursor: pointer; transition: all 0.15s;
}
.au-btn-warning:hover { background: #fef3c7; border-color: #f59e0b; }

.au-btn-danger {
  display: inline-flex; align-items: center;
  padding: 8px 18px; border-radius: 20px;
  border: 1.5px solid #fecaca; background: #fff5f5;
  color: #991b1b; font-size: 0.82rem; font-weight: 700;
  cursor: pointer; transition: all 0.15s;
}
.au-btn-danger:hover { background: #fee2e2; border-color: #ef4444; }

/* Username preview */
.au-username-preview {
  background: #FEF1E0; border-radius: 8px;
  padding: 8px 12px; font-size: 0.8rem; color: #C96A00;
  border: 1px solid #FBD9AE;
}

/* Optional badge (used in section titles) */
.au-optional-badge {
  font-size: 0.68rem; font-weight: 600; text-transform: uppercase;
  letter-spacing: 0.06em; color: #64748b;
  background: #f1f5f9; border: 1px solid #e2e8f0;
  border-radius: 20px; padding: 2px 10px; margin-left: auto;
}
</style>